import React, { useEffect, useState } from 'react'
import Topbar from '../../components/Topbar/Topbar'
import { URLS } from '../../Services/Constant';
import { get, post } from '../../Services/ApiHandler';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

const FailedTransactionView = () => {
  const [data, setData] = useState({});
  const [transactions, setTransactions] = useState([]);
  const location = useLocation();
  const [note, setNote] = useState("");
  const path = location.pathname?.replace("/", "");
  const id = location.state?.id ?? "";
  console.log("IDDD", id);

  const handleChange = (e) => {
    const { name, value } = e.target;
    // setData((prev) => ({ ...prev, [name]: value }));
  };

  const transactionFailed = async ({ id }) => {
    try {
      const res = await get(`${URLS.USER_FAILED_TRANSACTION_DETAILS}${id}`);
      console.log("RESPONSE:", res);

      if (res?.status === "success") {
        setTransactions(res?.data?.transactions);
        setData(res?.data);
      }
    } catch (err) {
      console.log("ERROR:", err);
    }
  };

  useEffect(() => {
    transactionFailed({ id });
  }, [id]);

  const handlerNotes = async () => {
    try {
      let pay = {
        alert_id: id,
        notes: note,
      };

      const res = await post(URLS.USER_FAILED_TRANSACTION_MARKREAD, pay);
      console.log("RESPONSE:", res);

      if (res.status == "success") {
        toast.success("Successfully Updated Notes");
      }
    } catch (err) {
      console.log("ERROR", err);
    }
  };

  return (
    <div>
      <Topbar header={"Payment Transaction"} subHead={"Failed Transaction"} back />
      <hr style={{ backgroundColor: "#D1D1D6" }}></hr>
      <div className="d-flex flex-wrap gap-5">
        <div className="col-md-5">
          <p className="f3 mb-1">User Name</p>
          <input
            className="input-box"
            name="name"
            value={data?.user_name}
            style={{ color: "#7f7f7f" }}
            type="text"
            placeholder="User Name"
            readOnly
          />
        </div>
        <div className="col-md-5">
          <p className="f3 mb-1">User ID</p>
          <input
            className="input-box"
            name="id"
            value={data?.user_code}
            style={{ color: "#7f7f7f" }}
            type="text"
            placeholder="User ID"
            readOnly
          />
        </div>
        <div className="col-md-5">
          <p className="f3 mb-1">Mobile Number</p>
          <input
            className="input-box"
            name="mobile"
            value={data?.phone_number}
            style={{ color: "#7f7f7f" }}
            type="text"
            placeholder="Mobile Number"
          />
        </div>
        <div className="col-md-5">
          <p className="f3 mb-1">No of Transaction</p>
          <input
            className="input-box"
            name="transaction"
            value={data?.failed_count}
            style={{ color: "#7f7f7f" }}
            type="text"
            placeholder="No of Transaction"
          />
        </div>
      </div>

      {/* list */}
      <div className="d-flex flex-wrap gap-5 mt-5">
        {(transactions ?? [])?.map((item, ind) => {
          return (
            <div className="col-md-5 bg-settings">
              <p className="f3 h5" style={{ color: "#A855F7" }}>
                Attempt {ind + 1}
              </p>
              <div className="d-flex flex-wrap gap-2 p-3 ">
                <div style={{ width: 'fit-content', minWidth: '48%' }} className="">
                  <p className="f3 mb-1">Transaction ID</p>
                  <input
                    className="input-box"
                    style={{ backgroundColor: "#ffffff", color: "#7f7f7f" }}
                    name="transaction_id"
                    value={item?.order_id}
                    type="text"
                    placeholder="Transaction ID"
                    readOnly
                  />
                </div>
                <div style={{ width: 'fit-content', minWidth: '48%' }}>
                  <p className="f3 mb-1">Failed date & time</p>
                  <input
                    className="input-box"
                    style={{ backgroundColor: "#ffffff", color: "#7f7f7f" }}
                    name="failed_date_time"
                    value={item?.date}
                    type="text"
                    placeholder="Failed date & time"
                    readOnly
                  />
                </div>
                <div style={{ width: 'fit-content', minWidth: '48%' }}>
                  <p className="f3 mb-1">Payment Gateway type</p>
                  <input
                    className="input-box"
                    style={{ backgroundColor: "#ffffff", color: "#7f7f7f" }}
                    name="payment_gateway_type"
                    value={item?.payment_type}

                    type="text"
                    placeholder="Payment Gateway type"
                  />
                </div>
                <div style={{ width: 'fit-content', minWidth: '48%' }}>
                  <p className="f3 mb-1">Amount</p>
                  <input
                    className="input-box"
                    style={{ backgroundColor: "#ffffff", color: "#7f7f7f" }}
                    name="amount"
                    value={item?.amount}

                    type="text"
                    placeholder="Amount"
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="col-disc-width mt-4" style={{position:'relative'}}>
        <p className="f3 mb-1">Description*</p>
        <textarea
          className="input-box"
          name="description"
          value={data?.notes || data?.description}
          onChange={(e) => setNote(e.target.value)}
          style={{ color: data?.notes !== null ? "#7f7f7f" : "#000000" }}
          type="text"
          placeholder="Body content of the notification....."
          multiline
          readOnly={data?.notes !== null}
        />
        {data?.notes === null && (
          <button className="btn-respond mt-3" onClick={handlerNotes}>
            Respond
          </button>
        )}
       {data?.admin && ( <p className='f3 mb-1' style={{position:'absolute',bottom:'15px',right:'20px',color:'rgb(168, 85, 247)'}}>{data?.admin} | {data?.admin_id}</p>)}
      </div>
    </div>
  );
}

export default FailedTransactionView
